import { Link } from 'react-router-dom'
import './Form.css'



function PrivacyPolicy() {
    return (
        <div>
            <div className='privacy-policy-btn' style={{}}><Link to='/' replace='true'>Back</Link></div>
            <strong style={{color: 'white'}}>DO NOT USE SCHEDULER IF YOU DO NOT AGREE TO THIS PRIVACY POLICY:</strong>

            <ul className='policy'>
                <li>Scheduler collects and stores all users' email addresses only for user authentication.</li>
                <li>Scheduler collects and stores all data as entered by the user when writing tasks items for their use only.</li>
                <li>Scheduler does NOT give away or sell user data to any outside or third-party sources.</li>
                <li>Scheduler makes use of LocalStorage for storing authentication tokens.</li>
            </ul>
        </div>
    )
}

export default PrivacyPolicy;